export const vue3Model = {
  prop: 'modelValue',
  event: 'update:modelValue'
}
